import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { Fragment, memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import Form from './form';

interface HeadProps {
  stateNotification?: string;
}

const HeadAccordionComponent = ({ stateNotification }: HeadProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="accordion-head-act-content"
          id="accordion-head-act-header"
          expandIcon={<ExpandMore />}
        >
          <Typography style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            Testata
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Form stateNotification={stateNotification} />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

HeadAccordionComponent.displayName = 'Head Accordion Component';

const HeadAccordion = memo(HeadAccordionComponent);

export default HeadAccordion;
